/* globals $:false */

var ReportDetailM = function(core, report) {
    this._core = core;
    this._report = report;
};

ReportDetailM.prototype.getReportId = function() {
    return this._report.id;
};

ReportDetailM.prototype.getReportFileName = function() {
    return this._report.reportFile;
};

ReportDetailM.prototype.getReportName = function() {
    return this._report.name;
};

ReportDetailM.prototype.getReportDescription = function() {
    return this._report.description;
};

ReportDetailM.prototype.hasParameters = function() {
    return this._report.parameterFormDefinition !== undefined;
};

ReportDetailM.prototype.getReportParameters = function() {
    return this._report.parameterFormDefinition;
};

ReportDetailM.prototype.setReportParameters = function(parameters) {
    this._report.parameterFormDefinition = parameters;
    return this;
};

ReportDetailM.prototype.hasReportEntities = function() {
    return this._report.entities !== undefined && this._report.entities.length > 0;
};

ReportDetailM.prototype.loadReport = function(reportName) {
    var _this = this;

    $.ajax({
        'url': 'reportm/reports/' + reportName,
        'type' : 'GET',
        success: function(report) {
            _this._report = report;

            _this._core.publish("reportm:report-loaded");
        },
        error: function(req) {
            window.console.log("REPORT:error: " + req.status + " : " + req.statusText + ":" + req.responseText);

            _this._core.publish("reportm:report-not-found");
        }
    });
};

ReportDetailM.prototype.generateReport = function(entities) {
    var _this = this;

    $.ajax({
        timeout: 600000,
        'url': _this.buildUri(entities),
        'type': 'post',
        'contentType':'application/json',
        'data': JSON.stringify(this._report),
        success: function(response) {
            window.console.log("Generate report file uri " + response.reportFileUri);
            window.location = response.reportFileUri;

            _this._core.publish("reportm:report-generated");
        },
        error: function() {
            _this._core.publish("reportm:report-generation-error");
        }
    });
};

ReportDetailM.prototype.buildUri = function(entities) {
    var url = this._report.generateUri;

    //If the user selected any equipment
    if(entities && entities.length > 0){
        url+="?entity=" + entities.join("&entity=");
    }

    return url;
};

export default ReportDetailM;
